<template>
  <el-dialog
    v-drag-dialog="drag"
    :title="title"
    :visible="isVisible"
    :close-on-click-modal="false"
    :before-close="beforeClose"
    @closed="closeDialog"
    :width="width"
    :show-close="showClose"
    :append-to-body="appendToBody"
    :fullscreen="fullscreen"
  >
    <slot></slot>
    <slot name="footer" slot="footer"></slot>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: [Boolean],
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '850px'
    },
    drag: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isVisible: false
    };
  },
  watch: {
    visible(newVal) {
      this.$nextTick(() => {
        this.isVisible = newVal;
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isVisible = this.visible;
    });
  },
  methods: {
    // 关闭弹窗前
    beforeClose: function () {
      this.isVisible = false;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.$emit('close', false);
    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.el-dialog {
  overflow: hidden;
  border-radius: 16px !important;
  .el-dialog__header {
    padding: 0 0 0 24px;
    height: 80px;
    // background: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-dialog__title {
      color: #1a1a1a;
      font-size: 18px;
      font-weight: bold;
    }
    .el-dialog__headerbtn {
      height: 80px;
      width: 72px;
      position: relative;
      top: auto;
      right: auto;
      .el-icon-close {
        color: #202945;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body{
    padding: 0 !important;
    // 弹窗
    .el-form-item{
      margin: 0 0 24px;
    }
    .el-form-item__label{
      font-weight: bold;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 4px;
      color: $--color-text-regular;
    }
    .dialog-body{
      padding: 24px 24px 0!important;
    }
  }
  .el-dialog__footer {
    height: 88px;
    padding: 0 24px;
    // background: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .el-button{
      padding: 0 44px !important;
      height: 40px;
      line-height: 40px;
    }
  }
}


</style>
